<template>
  <b-container class="app-footer">
      <p>Desarrollado por <a href="https://nayra.coop" target="_blank">nayra.coop</a></p>
  </b-container>
</template>

<script>

export default {

  data () {
    return {
      test: 'Hola'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/AppFooter.vue